import React, { PureComponent } from 'react';

export default class PBSPlayer extends PureComponent {
  render() {
    return <iframe
      className="video-player-external cove-video-player"
      ref={this.props.refCallback}
      src={`//player.pbs.org/widget/partnerplayer/${this.props.tpMediaId}/?callsign=ktca&uid=${this.props.uid}&autoplay=${this.props.autoplay}&endscreen=false`}
      allowFullScreen={true}
      scrolling="no"
      allow="autoplay; fullscreen; encrypted-media" />;
  }
}